<app-template>


  <app-base-list *ngIf="data" [filters]="crudService.filters" [sortBy]="crudService.orderBy" [filterLabels]="crudService.filterLabels" [sortDirection]="crudService.orderDirection" [tableConfig]="tableConfig" [data]="data" (action)="onAction($event.name, $event.data)"></app-base-list>

</app-template>
